<template>
    <a
        v-if="pageLayoutPartner"
        :class="['side-column', direction]"
        target="_blank"
        :aria-label="pageLayoutPartner?.clicked_partner_name"
        :href="clickOutHref()"
        @click="clickOutCheck()"
        rel="nofollow"
    >
        <BaseImage
            loadLazy
            class="column-image"
            :imgSource="imgSource"
            width="300"
            height="800"
            quality="100"
            alt="side column image"
        />
    </a>
</template>

<script>
import BaseImage from '@atoms/Image/BaseImage';
import { analyticsMixin, clickOutMixin, partnersMixin } from '@/mixins';
import { COT_SIDE_BANNER } from '@/constants';

export default {
    name: 'SideColumn',
    mixins: [partnersMixin, clickOutMixin, analyticsMixin],
    components: {
        BaseImage,
    },
    props: {
        direction: {
            type: String,
            default: 'left',
        },
    },
    computed: {
        imgSource() {
            const host = this.$globalConstants.host || {};
            const imageKey = 'background_image_' + this.direction;

            // check host level background settings
            if (host['standard_background_image'] && host[imageKey]) {
                return host[imageKey];
            }
            return this.pageLayoutPartner?.marketing_properties?.[imageKey];
        },
    },
    methods: {
        clickOutHref() {
            return this.goto(this.pageLayoutPartner?.cp_id, 1, COT_SIDE_BANNER);
        },
        clickOutCheck() {
            return this.clickout(
                'default',
                this.pageLayoutPartner?.clicked_partner_name,
                0,
                'backgroundimage'
            );
        },
    },
};
</script>

<style lang="scss" scoped>
.side-column {
    &.left {
        grid-column: 1;
    }
    &.right {
        grid-column: 3;
    }
}
.column-image {
    object-fit: cover;
    height: 100vh;
    width: 100%;
    position: sticky;
    top: 0;
}
</style>
